<template>
    <div class="com-partm8">
        <MyTitle title="实时负载" />
        <div class="p-content flex align-center flex-wrap">
            <div
                v-for="(item, i) in list"
                v-if=" item.label !== '大模型数量'"
                :key="'list' + i"
                class="item flex justify-center flex-direction">
                <img class="item-c" :src="item.icon" alt="" />
                <div class="item-l">{{ item.label }}</div>
                <dv-digital-flop style="height: 30px; width: 100%" :config="dvDigitalFlopConfig(item)" />
            </div>
        </div>
    </div>
</template>

<script>
import MyTitle from './myTitle1.vue'
import { dataInterface } from "@/api/dataInterfaceApi"
export default {
    components: {
        MyTitle
    },
    data() {
        return {
            list: [],
            timer: null
        }
    },
	mounted() {
		// 实时负载
		this.getData()
        this.timer = setInterval(() =>{
		    this.getData()
        },5000)
    },
	methods: {
        // 字体动态
        dvDigitalFlopConfig(item = {}) {
            let counts = parseFloat(item.value || 0)
            let config = {
                number: [parseFloat(counts)],
                textAlign: item.textAlign || 'center',
                content: `{nt}%`,
                style: {
                    fill: item.color || '#fff',
                    fontSize: item.fontSize || 32,
					fontFamily: 'DS-Digital-Bold'
                }
            }
            console.log('==config==', config)
            return config
        },
        // 实时负载
        getData() {
			let params = { 
				enCode: 'computingpower-right-ssfz',
			}
			dataInterface.dataFaceApi(params).then(res => {
				console.log(res, '实时负载')
                let data = res || []
                // this.list[0].value = data
                // let colors = [ '#28C89A', '#FFFFFF', '#FFD15C', '#FFD15C' ]
				this.list = data.map((item, i) => {
                    let icon = item.type == 'CPU' || item.type == 'GPU' ? item.type : (item.type == '内存' ? 'RAM' : 'memory')
                    return {
                        label: item.type,
                        value: item.load,
                        color: '#03B9BD', //colors[i],
                        icon: require(`@/assets/images/computility/monitor-icon-${icon}.png`),
                        textAlign: 'left',
                    }
                })
			})
        },
    },
    destroyed() {
        clearInterval(this.timer)
    }
}
</script>

<style lang="scss" scoped>
@import './comm.scss';
.com-partm8 {
    width: 100%;
    height: 340px;
    .p-content {
        width: 100%;
        height: 260px;
        .item {
            width: 50%;
            font-size: $FontSize20;
            padding: 10px 0 10px 100px;
            position: relative;
            .item-c {
                position: absolute;
                width: 80px;
                height: 65px;
                top: 50%;
                left: 0;
                transform: translate(0, -50%);
            }
        }
    }
}
</style>